/*let currentX, currentY, movementConstant = .015;
$(document).mousemove(function(e) {
	if(currentX === '') currentX = e.pageX;
	let x_diff = e.pageX - currentX;
	currentX = e.pageX;
	if(currentY === '') currentY = e.pageY;
	let y_diff = e.pageY - currentY;
	currentY = e.pageY;
	$('.parallax div').each(function(i, el) {
		let movement = (i + 1) * (x_diff * movementConstant);
		let movementy = (i + 1) * (y_diff * movementConstant);
		let newX = $(el).position().left + movement;
		let newY = $(el).position().top + movementy;
		$(el).css('left', newX + 'px');
		$(el).css('top', newY + 'px');
	});
});*/

function parallaxMouse() {
	if ($('#parallax-gift').length) {
		let scene = document.getElementById('parallax-gift');
		///new Parallax(scene);
	}
}

$(document).ready(function(e) {
	parallaxMouse();
});